<template>
  <section
    v-if="tab === 4"
    class="user-information p-4 bg-white box-shaddow20 border-r-10"
  >
    <div class="d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center gap-5 custom-border-right px-2">
        <FavoritesIcon />
        <h4 class="font-w-400 font-s-18 text-color-theme-dark m-0">
          لیست علاقه مندی ها
        </h4>
      </div>
    </div>
    <template v-if="status">
      <b-row id="skeletonImage">
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img></b-skeleton-img>
        </b-col>
      </b-row>
      <br />
      <br />
    </template>
    <template v-else>
      <div id="favoriteProduct">
        <Product
          v-for="(product, index) in favorite.data"
          :low-opacity="false"
          :key="index"
          :product="product"
        ></Product>
      </div>
      <div class="w-100 text-center py-5" v-if="favorite.data.length === 0">
        <svg
          width="66"
          height="65"
          viewBox="0 0 66 65"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33.0003 58.6351C32.1607 58.6351 31.3482 58.5268 30.6712 58.283C20.3253 54.7351 3.88574 42.1413 3.88574 23.5351C3.88574 14.0559 11.5503 6.36426 20.9753 6.36426C25.5524 6.36426 29.8316 8.15176 33.0003 11.3476C36.1691 8.15176 40.4482 6.36426 45.0253 6.36426C54.4503 6.36426 62.1149 14.083 62.1149 23.5351C62.1149 42.1684 45.6753 54.7351 35.3295 58.283C34.6524 58.5268 33.8399 58.6351 33.0003 58.6351ZM20.9753 10.4268C13.7982 10.4268 7.94824 16.3038 7.94824 23.5351C7.94824 42.033 25.742 52.3247 31.9982 54.4643C32.4857 54.6268 33.542 54.6268 34.0295 54.4643C40.2587 52.3247 58.0795 42.0601 58.0795 23.5351C58.0795 16.3038 52.2295 10.4268 45.0524 10.4268C40.9357 10.4268 37.117 12.3497 34.6524 15.6809C33.8941 16.7101 32.1607 16.7101 31.4024 15.6809C28.8837 12.3226 25.092 10.4268 20.9753 10.4268Z"
            fill="#C4C1C1"
          />
        </svg>
        <h5 class="font-w-500 font-s-18 text-color-theme-grey2 mt-3">
          محصول مورد علاقه ای وجود ندارد
        </h5>
      </div>
    </template>
    <section
      id="mainPaginationBlog"
      v-if="favorite && favorite.last_page > 1"
      class="weblog-list-pagination text-center my-4 p-2 bg-color-fa"
    >
      <section
        v-if="favorite"
        id="listPagination"
        class="list-pagination weblog-list-pagination text-center my-4 py-2"
      >
        <pagination
          :limit="1"
          :data="favorite"
          @pagination-change-page="changePage"
          :disabled="status"
          class="justify-content-center"
        >
          <span slot="prev-nav">
            <ZPrevSvg />
          </span>
          <span slot="next-nav">
            <ZNextSvg />
          </span>
        </pagination>
      </section>
      <!-- <pagination :data="blogs.posts.links" :router="true" @pagination-change-page="changePage"></pagination> -->
    </section>
  </section>
</template>
<script>
import Product from "@/parts/Front/components/product/Product";
import paginationMixin from "@/libraries/mixins/paginationMixin";
import ZPrevSvg from "@/parts/Front/components/shared/ZPrevSvg";
import ZNextSvg from "@/parts/Front/components/shared/ZNextSvg";
import { BRow, BCol, BSkeletonImg } from "bootstrap-vue";
import FavoritesIcon from "@/parts/Front/components/Icon/panelIcons/Favorites.vue";
export default {
  mixins: [paginationMixin],
  props: { tab: { Number } },
  components: {
    ZNextSvg,
    ZPrevSvg,
    Product,
    FavoritesIcon,
    BRow,
    BCol,
    BSkeletonImg,
  },
  data() {
    return {
      loading: false,
      allow: false,
    };
  },
  created() {
    if (this.favorite == null) {
      this.$store.dispatch(
        "front/getFavoriteFromServer",
        this.$route.query.page != undefined ? this.$route.query.page : "1"
      );
    }
  },
  watch: {
    favorite(newVal) {
      if (newVal != null) {
        this.loading = true;
      }
    },

    "$route.query.page": {
      handler: function (val) {
        let page = val;
        if (this.allow)
          this.$store.dispatch("front/getFavoriteFromServer", page);
      },
      immediate: true,
    },
  },
  computed: {
    status() {
      return this.$store.getters["front/getFavoriteStatus"];
    },
    favorite() {
      if (this.$store.getters["front/getFavorite"] == null) {
        return this.$store.getters["front/getFavorite"];
      } else {
        return this.$store.getters["front/getFavorite"].favorite;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.allow = true;
    }, 5000);
  },
};
</script>
<style scoped>
#skeletonImage {
  display: flex;
  justify-content: space-around;
}
#favoriteProduct {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 1em;
}

@media screen and (max-width: 992px) {
  #favoriteProduct {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
